import React, { useState, useEffect } from "react";
import styles from "./GPSChecker.module.scss";
import ReactModalWrap from "../UI/Modals/ReactModalWrap/ReactModalWrap";
import Button from "../UI/Buttons/Button/Button";

const GPSChecker: React.FC = () => {
  const [isGPSEnabled, setIsGPSEnabled] = useState<boolean | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    checkGPS();
  }, []);

  const checkGPS = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setIsGPSEnabled(true);
        const { latitude, longitude } = position.coords;
        console.log("Latitude:", latitude);
        console.log("Longitude:", longitude);
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED || error.code === error.POSITION_UNAVAILABLE) {
          setIsGPSEnabled(false);
          setShowModal(true);
        }
      }
    );
  };

  const openLocationSettings = () => {
    if (/Android/i.test(navigator.userAgent)) {
      window.location.href = "intent://settings/#Intent;scheme=android.settings.LOCATION_SOURCE_SETTINGS;end;";
    } else {
      alert("Please enable location services in your device settings.");
    }
  };

  return (
    <ReactModalWrap close={() => setShowModal(false)} isOpen={showModal}>
      <div className={styles.modalContent}>
        <h3 className={styles.header}>GPS servis je onemogucen</h3>
        <h5 className={styles.subheader}>Molimo vas da omogućite u svojim podešavanjima</h5>
        <Button buttonType="blue" onClick={openLocationSettings}>
          Omogući GPS
        </Button>
      </div>
    </ReactModalWrap>
  );
};

export default GPSChecker;
